module.exports = __webpack_public_path__ + "img/security_key.7405bb38.png";